import {Outlet, RouteObject, useRoutes} from 'react-router-dom';
import {NotFoundPage} from '@common/ui/not-found-page/not-found-page';
import { AuthRoute } from '@common/auth/guards/auth-route';
import { TeamMemberPage } from '@app_modules/member/my-team-page';
import { TeamPage } from './teams-page';
import { ActiveTeamProvider } from './active-team-id-context';
import { MyTeamPage } from '@app_modules/my-team/my-team-page';

export default function TeamsRoutes() {
  const DashboardRouteConfig: RouteObject[] = [
    {
      path: '',
      element: (
        <ActiveTeamProvider>
          <Outlet />
        </ActiveTeamProvider>
      ),
      children: [
        {
          path: '/',
          element: (
            <AuthRoute permission="teams.view">
              <TeamPage />
            </AuthRoute>
          ),
        },

        

        {
          path: '/join/:workspaceInvite',
          element: (
            <AuthRoute permission="teams.view">
              <MyTeamPage />
            </AuthRoute>
          ),
        },

        {
          path: '/decline/:workspaceInvite',
          element: (
            <AuthRoute permission="teams.view">
              <MyTeamPage />
            </AuthRoute>
          ),
        },

        {path: '*', element: <NotFoundPage />},
      ],
    },
  ];

  return useRoutes(DashboardRouteConfig);
}
